<ng-container *ngIf="buttons$ | async as buttons">
  <ng-container *ngIf="buttons">
    <ion-button
      *ngFor="let button of buttons" [slot]="button.slot ? button.slot : 'start'"
      [color]="button.color ? button.color : 'primary'"
      [fill]="button.fill ? button.fill : 'solid'"
      [size]="button.size ? button.size : 'default'"
      (click)="button.callback()">
      {{button.label}}
    </ion-button>
  </ng-container>
</ng-container>
